angular.module('app.filters').filter('boxcastFlowControl', () =>
  input => {
    const requestedLatency = input[0];
    const targetLatency = input[1];
    const latency = (requestedLatency != '') ? requestedLatency : targetLatency;
    switch (latency) {
      case 'default':
        return 'Default BoxCast Flow control (use BoxCaster setting or 2s)';
        break;

      case 'standard':
        return 'Standard BoxCast Flow control (2s)';
        break;

      case 'enhanced':
        return 'Enhanced BoxCast Flow control (15s)';
        break;

      case 'maximum':
        return 'Maximum BoxCast Flow control (45s-90s)';
        break;

      default:
        return `Unknown (${latency})`;
        break;
    }
  }
);


// WEBPACK FOOTER //
// ./filters/boxcast_flow_control.js